import './specialInput.scss'
import clsx from 'clsx'
import { useRef } from 'react'
import { NiceChannelBox } from '../../nice-channel-box'
import { parseTelegramPeerReference } from '@synapex/shared2/telegram'

interface SpecialInputProps {
    value: string
    title: string | null
    channelName: string | null
    channelId: number
    onChannelNameChange: (channelName: string | null) => void
    onChange: (value: string) => void
    placeholder?: string
    className?: string
    disabled?: boolean
    hasError?: boolean
}

export const SpecialInput = ({
    value,
    title,
    channelName,
    channelId,
    onChange,
    onChannelNameChange,
    placeholder = 'Введите @название канала или ссылки',
    className = '',
    disabled = false,
    hasError = false,
}: SpecialInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null)

    const handleBlur = async () => {
        const trimmedValue = value.trim()

        if (parseTelegramPeerReference(trimmedValue)) {
            onChannelNameChange(trimmedValue)
            onChange('')
        } else {
            onChannelNameChange(null)
        }
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value)
    }

    const handleRemoveChannel = () => {
        onChannelNameChange(null)
        onChange('')
        inputRef.current?.focus()
    }

    let username: string | null | undefined = undefined
    let invite_hash: string | null | undefined = undefined

    const ref = channelName
        ? parseTelegramPeerReference(channelName)
        : undefined

    if (ref) {
        username = ref.username
        invite_hash = ref.invite_hash
    }

    return (
        <div
            className={clsx('special-input', className, {
                disabled,
                'has-error': hasError,
            })}
        >
            <div className="special-input__wrapper">
                <input
                    ref={inputRef}
                    type="text"
                    value={channelName ? '' : value}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    placeholder={channelName ? '' : placeholder}
                    className="special-input__field"
                    disabled={disabled || !!channelName}
                />
                {channelName && (
                    <NiceChannelBox
                        {...{ username, invite_hash }}
                        title={title || undefined}
                        channelId={channelId}
                        onRemove={handleRemoveChannel}
                        className="special-input__channel-box"
                    />
                )}
            </div>
        </div>
    )
}
